import { SAVINGS_RECEIVED, SAVINGS_ASOF_RECEIVED, SAVINGS_UNLOADED, SAVINGS_SAVED, SAVINGS_DELETED } from './types'
import api from 'api'

export const savingDataReceived = data => ({
  type: SAVINGS_RECEIVED,
  data
})

export const savingsAsOfReceived = data => ({
  type: SAVINGS_RECEIVED,
  data
})

export const savingDataUnload = () => ({
  type: SAVINGS_UNLOADED
})

export const savingSaved = data => ({
  type: SAVINGS_SAVED,
  data
})

export const savingDeleted = data => ({
  type: SAVINGS_DELETED,
  data
})

export const unloadSavings = () => dispatch => {
  dispatch(savingDataUnload())
}

export const deleteSaving = data => dispatch =>
  api.bmc.savings.deleteSaving(data).then( res => {
    dispatch(savingDeleted(data))
  })

export const saveSaving = data => dispatch =>
  api.bmc.savings.postSaving(data).then( res => {
    dispatch(savingSaved(res))
    return res.id
  })

export const getSavings = planid => dispatch =>
  api.bmc.savings.getSavings(planid).then( data => {
    dispatch(savingDataReceived(data))
  })

export const getSavingsAsOf = (year, planid) => dispatch =>
  api.bmc.savings.getSavingsAsOf(year, planid).then(res => {
    dispatch(savingsAsOfReceived(res))
})